import * as consts from '../const';
import { progressBarStepsIcon } from '~/assets/icons/js/progressBarStepsIcon';
export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;
    /* Set css progressbar */
    editor.Config.canvasCss += consts.progressbar_css;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,
            tagName:'div',
            classes:['fixed-top'],
            style:{
                display:'block'
            },
            attributes:{
                "data-slg-type":"C-PROGRESS-BAR-STEPS"
            },
            script: function () {
                let items = this.querySelectorAll('.progressbar .step');
                function disableNext(items,index){
                    if(items[index] && items[index].classList.contains('active')){
                        items[index].classList.remove('active');
                        // Disable next
                        disableNext(items,index+1);
                    }   
                }
                function activeBefore(items,index){
                    if(items[index] && !items[index].classList.contains('active')){
                        items[index].classList.add('active');
                        // Active before
                        activeBefore(items,index-1);
                    }   
                }
                for(let i=0; i < items.length; i++){
                    const item = items[i];
                    let width = 100 / items.length;
                    item.style.width = `${width}%`
                    /* item.addEventListener('click',()=>{
                        item.classList.toggle('active');
                        disableNext(items,i+1);
                        if(item.classList.contains('active')){
                            activeBefore(items,i-1);  
                        }
                    }); */
                }
            },
            components:[
                {
                    tagName: 'div', 
                    classes:["progressbar"],
                    components:[]
                },
                
            ],
            traits: [
                {
                    type: 'class_select',
                    options: [
                        {value: '', name: 'None'},
                        {value: 'fixed-top', name: 'top'},
                        {value: 'fixed-bottom', name: 'bottom'},
                    ],
                    label: 'Position'
                }
            ].concat(MODEL.prototype.defaults.traits)

        }
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-PROGRESS-BAR-STEPS")
                    return { type:'C-PROGRESS-BAR-STEPS' }
        }
    });

    var view = VIEW.extend({

        init() {
            this.updateProgressBar()
        },

        updateProgressBar() {
            const sm = editor.StorageManager;
            const sm_steps = sm.get(opts.storage_name);
            const current_step = sm_steps.current_step;
            const list_steps = sm_steps.list_steps;

            let last_step_active = 0;
            for (let i = 0; i < list_steps.length; i++) {
                const step = list_steps[i];
                if(step.id == current_step){
                    last_step_active = i;
                }
            }

            let components_progress = this.model.components().models[0];
            let components_steps = components_progress.components().models;
            for (let i = 0; i < list_steps.length; i++) {
                if(components_steps.length <= i){
                    const step = list_steps[i];
                    let active = false;
                    if(i <= last_step_active){
                        active = true;
                    }
                    let label = `Step ${step.order_step}`;
                    this.createProgressBarStep(label, active, step.order_step);
                } 
            }

        },

        createProgressBarStep(label, active, icon, id) {
            let components_progress = this.model.components().models[0];
            let class_active = "";
            if(active)
                class_active = "active"
            components_progress.append(
                {
                    tagName:'div',
                    classes:['step',class_active],
                    components:[
                        {
                            tagName:'div',
                            classes:['block'],
                            components:[
                                {
                                    tagName:'div',
                                    classes:['icon'],
                                    content:icon
                                },
                                {
                                    tagName:'div',
                                    classes:['label'],
                                    content:label
                                }
                            ]
                        },
                        {
                            tagName:'div',
                            classes:['connector']
                        }
                    ]
                }
            )

        }

    });

    DOMC.addType('C-PROGRESS-BAR-STEPS', {
      model,
      view,
    });

    BM.add('B-PROGRESS-BAR-STEPS', {
        label: "PROGRESS BAR STEPS",
        content: { 
          type: 'C-PROGRESS-BAR-STEPS',
         },
         category:"ADVANCE COMPONENT",
        media: progressBarStepsIcon,
    });
};